import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * BUG-platform — Reusable sortable column header.
 * Pairs with `useSort()` from `@/lib/useSort`. Drop-in for any TableHead.
 *
 *   <SortableHeader sort={sort} k="name" testIdPrefix="evals">
 *     {t('pages.evaluations.evaluatee')}
 *   </SortableHeader>
 */
export function SortableHeader({
  sort,
  k,
  className,
  testIdPrefix = 'sort',
  align = 'left',
  children,
}) {
  const dir = sort.dirOf(k);
  const Icon = dir === 'asc' ? ArrowUp : dir === 'desc' ? ArrowDown : ArrowUpDown;
  return (
    <button
      type="button"
      onClick={() => sort.toggle(k)}
      data-testid={`${testIdPrefix}-sort-${k}`}
      aria-sort={dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none'}
      className={cn(
        'inline-flex items-center gap-1 hover:text-foreground transition-smooth select-none cursor-pointer text-inherit',
        align === 'right' ? 'justify-end' : 'justify-start',
        className,
      )}
    >
      {children}
      <Icon className={cn('h-3 w-3', dir ? 'opacity-80' : 'opacity-40')} />
    </button>
  );
}
